<template>
	<section>
		<!--工具条-->
		<el-col :span="100" class="toolbar" style="padding-bottom: 0px;">
<!--		<el-col :span="100"  style="padding-bottom: 0px;">-->
			<el-form :inline="true" :model="filters">
<!--        <el-form-item>-->
<!--          <el-input-->
<!--              v-model="filters.phone_number"-->
<!--              placeholder="输入手机">-->
<!--          </el-input>-->
<!--        </el-form-item>-->

<!--        <el-form-item>-->
<!--          <el-input-->
<!--              v-model="filters.account"-->
<!--              placeholder="输入帐号">-->
<!--          </el-input>-->
<!--        </el-form-item>-->

<!--        <el-form-item>-->
<!--					<el-input-->
<!--              v-model="filters.userName"-->
<!--              placeholder="输入用户名">-->
<!--          </el-input>-->
<!--				</el-form-item>-->

        <el-form-item>
          <el-select
              v-model="filters.type"
              placeholder="请选文件类型">
            <el-option
                v-for="item in typeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

				<el-form-item>
					<el-button type="primary" v-on:click="GetFileListInfo(0)">查询</el-button>
				</el-form-item>
<!--        <el-form-item>-->
<!--          <el-button   type="primary" v-on:click="openDetailFormVisible">新增</el-button>-->
<!--        </el-form-item>-->

      </el-form>

		</el-col>

		<!--列表-->
		<el-table :data="fileInfo" highlight-current-row v-loading="listLoading"   style="width:100%;"  :header-cell-style="{'text-align':'center'}">
			<el-table-column type="index"  width="40"></el-table-column>
      <el-table-column prop="key" label="key" width="100" align="center" sortable></el-table-column>
      <el-table-column prop="type" label="类型" width="70" align="center" :formatter="typeFormatter"> </el-table-column>
      <el-table-column prop="update_date" label="更新时间" width="120" align="center"  sortable>
        <!--        <template slot-scope="scope">-->
        <!--          <span>{{scope.row.update_date.substring(0,10)}}</span>-->
        <!--        </template>-->
      </el-table-column>
      <el-table-column prop="description" label="说明" width="200" align="center" > </el-table-column>



<!--      <el-table-column prop="owner" label="创建人" width="80" align="center"  sortable></el-table-column>-->
<!--      <el-table-column prop="description" label="说明" min-width="100" align="center"  ></el-table-column>-->
			<el-table-column label="操作" width="240" align="center">
				<template slot-scope="scope">
<!--					<el-button    size="small"-->
<!--                        :type="scope.row.status === 1 ? 'warning' : 'success'"-->
<!--                        @click="handleEditStatus(scope.$index, scope.row)">-->
<!--                         {{ scope.row.status === 1 ? '禁用' : '激活' }}-->
<!--          </el-button>-->
<!--					<el-button    size="small" type="warning"  @click="handleEditReset(scope.$index, scope.row)">重置</el-button>-->
					<el-button    size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
<!--					<el-button  type="danger" size="small" @click="handleDel(scope.$index, scope.row)">删除</el-button>-->
				</template>
			</el-table-column>

		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
<!--			<el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button>-->
<!--			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="page_size" :total="total" style="float:right;">-->
<!--			</el-pagination>-->

      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[20,30,50,100, 200, 500, 1000]"
          :page-size="page_size"
          layout="total, sizes, prev, pager, next"
          :total="total"
          >
      </el-pagination>
		</el-col>



    <!--详情界面-->
		<el-dialog title="广告详情" v-model="detailFormVisible" :close-on-click-modal="false" >
			<el-form :model="detailForm" label-width="80px" :rules="detailFormRules" ref="detailForm" width="200px">
        <el-row>
        <el-col :span="8">
            <el-form-item label="key">
              <el-input v-model="detailForm.key" :readonly="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="22">
            <el-form-item label="文件类型">
              <el-select v-model="detailForm.type" placeholder="请选择文件类型" @change="handleTypeChange" :disabled="true">
                <el-option
                    v-for="item in typeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="22">
            <el-form-item label="文件显示">
              <div style="display: flex; align-items: center;">
                <!-- 图片预览 -->
                <img
                    v-if="isBase64Image(detailForm.value)"
                    :src="detailForm.value"
                    alt="文件预览"
                    style="max-width: 200px; max-height:200px; margin-right: 10px;"
                />
                <!-- 上传按钮，仅当 type 为 'img' 时显示 -->
                <el-upload
                    v-if="detailForm.type === 'img'"
                    action="#"
                    :before-upload="beforeUpload"
                    :show-file-list="false"
                >
                  <el-button size="small" type="primary">上传图片</el-button>
                </el-upload>
                <!-- 非图片类型显示输入框 -->
                <el-input type="textarea" v-if="detailForm.type !== 'img'" v-model="detailForm.value" class="custom-textarea"></el-input>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="22">
            <el-form-item label="说明">
              <el-input  v-model="detailForm.description"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
			</el-form>


      <div slot="footer" class="dialog-footer"  >
        <el-button type="primary"   @click="saveFile">保存</el-button>

        <el-button   @click.native="detailFormVisible = false">返回</el-button>
			</div>

		</el-dialog>
	</section>


</template>

<script>
import util from "../../common/js/util";
import {
  getUserListPage,
  removeUser,
  batchRemoveUser,
  getOrderInfoListPage,
  getAllType,
  updateOrder,
  getOrderListExcelEx,
  postUpload,
  removeOrder,
  getTodayOrderSnCode,
  getBarcodeList,
  getSalesmanInfoPage,
  GetUserListInfo,
  saveSalesmanInfo,
  saveUserInfo,
  removeSalesman,
  GetUserListPage, getUserSn, GetFileListPage, saveFileInfo

} from "../../api/api";

import {getLodop} from '../../LodopFuncs'
import {consignmentPrint} from '../../printModel'
import {hasPermission} from '../../premission'
import {dateToString} from '../../common/js/util'
import itemStyle from "echarts/src/model/mixin/itemStyle";

// import fileDownload from "js-file-download";



export default {
  data() {
    return {
      filters: {
        type: "all",
        key: "1",
        all: "1"
      },
      orderInfo: [],
      page_size: 30,
      statusList:[],
      customs_clearance_typeList:[],
      payment_typeList:[],
      freight_typeList:[],
      total: 0,
      page: 1,
      init_order_id:'',
      order_sn:'',
      barcodeList:'',
      listLoading: false,
      sels: [], //列表选中列

      detailFormVisible: false, //详情界面是否显示
      editLoading: false,
      detailFormRules: {
        name: [{ required: true, message: "请输入运单", trigger: "blur" }]
      },
      //详情界面数据
      detailForm: {
        key : '',
        type: '',
        description: "",
        value: "",
      },
      defaultTime: '00:00:00' ,// 默认时间为 00:00:00
      typeOptions: [
        { value: 'all', label: '全部' },
        { value: 'img', label: '图片' },
        { value: 'HTML', label: 'HTML' },
      ],
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      creation_date: '',
      value2: ''
    };
  },
  methods: {
    isBase64Image(value) {
      // 检查是否是 Base64 图片（简单判断以 data:image 开头）
      return typeof value === 'string' && value.startsWith('data:image');
    },

    // 处理图片上传并转为 Base64
    beforeUpload(file) {
      // 可选：限制文件类型和大小
      if (!file.type.startsWith('image/')) {
        this.$message.error('请上传图片文件');
        return false;
      }
      if (file.size / 1024 / 1024 > 0.25) {
        this.$message.error('图片大小不能超过 250K');
        return false;
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        this.detailForm.value = e.target.result; // 更新为 Base64 字符串
      };
      reader.readAsDataURL(file);
      return false; // 阻止默认上传
    },

    handleCurrentChange(val) {
      this.page = val;
      this.GetUserListInfo();
    },

    handleSizeChange(val) {
      console.log(val)
      this.page = 1
      this.page_size = val;
      this.GetUserListInfo();
    },
    saveUser(){
      this.detailFormVisible = false;
      saveUserInfo(this.detailForm).then(res => {
        this.listLoading = false;
        let msg = res.msg

        this.$message({
            message: msg,
            type: "success"
          });

        this.GetUserListInfo();

      });
    },
    saveFile(){
      this.detailFormVisible = false;
      saveFileInfo(this.detailForm).then(res => {
        this.listLoading = false;
        let msg = res.message

        this.$message({
          message: msg,
          type: "success"
        });

        this.GetFileListInfo();

      });
    },

    limitMaxvalue(){
      if(this.detailForm.number > 999){
        this.detailForm.number = 1;
        this.$message("件数最多只能输入999");
      }
    },

    typeFormatter(row, column, cellValue) {
      switch (cellValue) {
        case "img":
          return '图片';
        case "HTML":
          return 'HTML';
        default:
          return '未知'; // 可选：处理未定义的类型
      }
    },

    handleTypeChange(type) {
      //自动配置有效期
      const now = new Date();
      now.setHours(0, 0, 0, 0); // 设置为当天的 00:00:00
      let effectiveTime = '';

      switch (type) {
        case 10: // 永久
          effectiveTime = '9999-12-31 00:00:00';
          break;
        case 20: // 订阅，1 个月后
          now.setMonth(now.getMonth() + 1);
          effectiveTime = this.formatDate(now);
          break;
        case 30: // 试用，1 天后
          now.setDate(now.getDate() + 1);
          effectiveTime = this.formatDate(now);
          break;
        default:
          effectiveTime = ''; // 未选择时为空
      }

      this.detailForm.effective_time = effectiveTime;
    },
    formatDate(date) {
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, '0');
      const d = String(date.getDate()).padStart(2, '0');
      return `${y}-${m}-${d} 00:00:00`;
    },


    getAllTypeInfo() {
      let para = {};
      this.listLoading = true;
      //NProgress.start();
      getAllType(para).then(res => {
        this.statusList = res.data.status;
        this.customs_clearance_typeList = res.data.customs_clearance_type;
        this.payment_typeList = res.data.payment_type;
        this.freight_typeList = res.data.freight_type;
        // console.log(this.freight_typeList)
      });
    },

    sourceFormat(val,brandList) {
      // 可以输出看下 val 是什么，方便匹配；
      // :formatter="sourceFormat"    val 就应该是 val.processField
      let branchName = val
      brandList.forEach(item => {
        if(item.key == val) {
          branchName = item.value
          return branchName
        }
      })
      return branchName
    },



//获取列表
    GetUserListInfo() {
      //{"page":1,"pageSize":10,"project_name":null,"app_name":"web-uam.jar","created_by_name":null}
      let creation_date = []
      if (this.filters.creation_date != null){
        if(this.filters.creation_date[0] != null && this.filters.creation_date[1] != null) {
          creation_date[0] = dateToString(this.filters.creation_date[0]);
          creation_date[1] = dateToString(this.filters.creation_date[1]);
        }
      }
      let para = {
        page: this.page,
        pageSize: this.page_size,
        userName: this.filters.userName,
        account: this.filters.account,
        phone_number: this.filters.phone_number,
        type: this.filters.type,
      };
      console.log(para);
      this.listLoading = true;
      //NProgress.start();
      GetUserListPage(para).then(res => {

        let code = res.code
        let msg = res.msg
        // console.log(code)
        if (code != 0){
          this.$message(msg)
          this.$router.push({ path: '/login' });
        }
        this.total = res.data.pagintion.rowTotal;
        this.page_size = res.data.pagintion.pageSize;
        this.userInfo = res.data.result;
        this.listLoading = false;
      });
    },

    GetFileListInfo(all=1) {
      //{"page":1,"pageSize":10,"project_name":null,"app_name":"web-uam.jar","created_by_name":null}
      let creation_date = []
      if (this.filters.creation_date != null){
        if(this.filters.creation_date[0] != null && this.filters.creation_date[1] != null) {
          creation_date[0] = dateToString(this.filters.creation_date[0]);
          creation_date[1] = dateToString(this.filters.creation_date[1]);
        }
      }
      if (this.filters.type == 'all'){
        all = "1"
      };

      let para = {
        key: this.filters.key,
        all: all,
        type: this.filters.type,
      };
      console.log(para);
      this.listLoading = true;
      //NProgress.start();
      GetFileListPage(para).then(res => {

        let code = res.code
        let msg = res.msg
        // console.log(code)
        if (code != 0){
          this.$message(msg)
          this.$router.push({ path: '/login' });
        }
        this.total = 1;
        this.page_size = 1;
        this.fileInfo = res.data;
        this.listLoading = false;
      });
    },






    //显示详情界面
    handleEdit: function(index, row) {
      this.detailFormVisible = true;
      this.detailForm = Object.assign({}, row);
    },
    //显示详情界面



    openDetailFormVisible: function() {

      let para = {aa:"bb"}



      getUserSn(para).then(res => {

        let account = res.data.user_sn

        this.resetForm(account);

      });

      this.detailFormVisible = true;
      this.editMark = true;
    },

    openUpload: function() {
      this.upload = true;
    },

    resetForm(account) {
        // this.$refs[formName].resetFields();
        this.detailForm = {
          id: 0,
          account: account,
          passwd: "",
          username: "",
          description: "",
        };
    },



    // 上传
    onUpload (file) {
      let formData = new FormData()

      formData.append('file',file.file)
      postUpload(formData).then((res) => {
        formData.length = 0
        let count = res.data.data.count
        // console.log(formData)
        let msg =  "成功上传" + count + "条记录。"
        this.$message.success(msg)
        this.getOrderInfo();
        setTimeout(
            ()=>{
              location.reload();
            } , 3000)
      }).catch((e) => {
        this.$message.error(e.message)
      })
    },



      checkHasPermission: function(button_name,view_name) {
      return hasPermission(button_name,view_name);
    },

    selsChange: function(sels) {
      this.sels = sels;
    },
    //批量删除
    batchRemove: function() {
      var ids = this.sels.map(item => item.id).toString();
      this.$confirm("确认删除选中用户吗？", "提示", {
        type: "warning"
      })
        .then(() => {
          this.listLoading = true;
          let para = { ids: ids };
          batchRemoveUser(para).then(res => {
            this.listLoading = false;
            let { msg, code } = res.data;
            if (code !== 200) {
              this.$message({
                message: msg,
                type: "warning"
              });
            } else {
              this.$message({
                message: msg,
                type: "success"
              });
            }
            this.getUsers();
          });
        })
        .catch(() => {});
    }
  },
  mounted() {
    // this.GetUserListInfo();
    this.GetFileListInfo();
    // this.getAllTypeInfo();
  }
};
</script>

<style scoped>

</style>

<style>
.readonly-input input {
  background-color: #f0f0f0; /* 设置背景颜色为灰色 */
  color: #999; /* 设置文字颜色为灰色 */
  cursor: not-allowed; /* 设置鼠标样式为禁止符号 */
}

.center {
  position: absolute;
  left: 50%;
  //top: 50%;
  transform: translate(-50%, -50%);
  width: 100px;
  height: 100px;
}

.el-dialog{
  width: 600px;
}


.custom-textarea textarea {
  height: 200px; /* 文本框高度 */
}
</style>





// WEBPACK FOOTER //
// adManage.vue?20bb0862